<!-- Header -->
<h3 mat-dialog-title translate>
	Note:
</h3>

<!-- Body -->
<mat-dialog-content translate>
	Your email address is also used as your Username, so changes made here will also affect the name you use to log in.
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
	<div class="footerRight">
		<save-cancel-buttons (saveButtonEvent)="confirm($event)"></save-cancel-buttons>
	</div>
</mat-dialog-actions>